export const NOT_AVAILABLE = 'N/A';
export const IS_SAFARI = navigator.vendor.includes('Apple');